module.exports = __webpack_public_path__ + "img/hy3.cb3f7eb2.png";